import { IoMdExit } from "react-icons/io";
import { IoExitOutline } from "react-icons/io5";
import { Link } from "react-router-dom"

const JadwalLoadingRoute = () => {
  return (
    <div>
      <div className="bg-white rounded-xl p-4">
        <h1 className="text-center text-xl md:text-2xl lg:text-4xl font-semibold">Jadwal Loading</h1>
      </div>

      <div className="grid grid-cols-2 gap-4 mt-10">
        <div className="bg-white p-4 lg:min-h-[200px] flex items-center justify-center rounded-xl hover:bg-gray-200 transition-all ease-in-out duration-500 hover:cursor-pointer">
          <Link to={"/jadwal-loading/in"} className="flex items-center flex-col gap-2 w-full">
            <IoMdExit size={50} />
            <label className="text-xl font-semibold">Loading In</label>
          </Link>
        </div>
        <div className="bg-white p-4 lg:min-h-[200px] flex items-center justify-center rounded-xl hover:bg-gray-200 transition-all ease-in-out duration-500 hover:cursor-pointer">
          <Link to={"/jadwal-loading/out"} className="flex items-center flex-col gap-2 w-full">
            <IoExitOutline size={50} />
            <label className="text-xl font-semibold">Loading Out</label>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default JadwalLoadingRoute